import { Link } from 'react-router-dom';
import { Truck, Package, Clock, DollarSign, Mail } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
];

function Shipping() {
  return (
    <div className="substack-site">
      <Header navItems={NAV_ITEMS} />

      <main className="shipping-page">
        <div className="shipping-container">
          <div className="shipping-header">
            <Truck size={48} />
            <h1>Shipping Policy</h1>
            <p>We ship all orders via USPS from the Outer Banks, North Carolina</p>
          </div>

          <div className="shipping-intro" style={{ 
            background: '#fff', 
            padding: '30px', 
            borderRadius: '12px', 
            marginBottom: '30px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
          }}>
            <p style={{ fontSize: '18px', lineHeight: '1.7', marginBottom: '15px' }}>
              It is our priority to deliver your order ASAP. And once your order ships, we will notify you by email and provide the tracking info. Because we ship with USPS, I can ship to a P.O. Box, APO, home, or business address.
            </p>
            <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.7' }}>
              Most of the time your order will ship out on the next business day from Edenton. During peak season, it's normally no more than 3 business days based on when your order is received. Please note that weekends and holidays are not business days. I'm sorry it needs to be said, but shipping has become a bit of a nightmare. We will do everything we can to stay on top of shipment delivery.
            </p>
          </div>

          <div className="free-shipping-banner">
            <DollarSign size={24} />
            <span>FREE SHIPPING on orders over $75!</span>
          </div>

          <div className="shipping-tables">
            {/* General / Prints / Tees Shipping */}
            <div className="shipping-category">
              <h2>
                <Package size={20} />
                Prints, Tees & General Merchandise
              </h2>
              <table className="shipping-table">
                <thead>
                  <tr>
                    <th>Order Total</th>
                    <th>Shipping Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>$0.01 - $50.00</td>
                    <td>$8.95</td>
                  </tr>
                  <tr>
                    <td>$50.01 - $75.00</td>
                    <td>$9.95</td>
                  </tr>
                  <tr className="free-row">
                    <td>$75.01+</td>
                    <td className="free">FREE</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Drinkware Shipping */}
            <div className="shipping-category">
              <h2>
                <Package size={20} />
                Drinkware (B.B. Muggs)
              </h2>
              <table className="shipping-table">
                <thead>
                  <tr>
                    <th>Order Total</th>
                    <th>Shipping Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>$0.01 - $29.99</td>
                    <td>$8.00</td>
                  </tr>
                  <tr className="free-row">
                    <td>$30.00+</td>
                    <td className="free">FREE</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Notecards Shipping */}
            <div className="shipping-category">
              <h2>
                <Package size={20} />
                Mostly Good Notecards
              </h2>
              <table className="shipping-table">
                <thead>
                  <tr>
                    <th>Order Total</th>
                    <th>Shipping Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>$0.01 - $6.00</td>
                    <td>$2.00</td>
                  </tr>
                  <tr>
                    <td>$6.01 - $18.00</td>
                    <td>$3.00</td>
                  </tr>
                  <tr>
                    <td>$18.01 - $26.99</td>
                    <td>$4.00</td>
                  </tr>
                  <tr className="free-row">
                    <td>$27.00+</td>
                    <td className="free">FREE</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="shipping-info-cards">
            <div className="info-card">
              <Clock size={28} />
              <h3>Processing Time</h3>
              <p>Orders ship within 1-3 business days from Edenton, NC. Fine art prints may take 5-7 business days as they are made to order.</p>
            </div>
            <div className="info-card">
              <Mail size={28} />
              <h3>Questions?</h3>
              <p>Contact us at <a href="mailto:support@theobxbeachbum.com" style={{ color: '#1a1a1a' }}>support@theobxbeachbum.com</a> or call <strong>1-252-378-8844</strong></p>
            </div>
          </div>

          <div className="shipping-note">
            <p><strong>Note:</strong> Shipping costs are calculated per product category. If you order items from multiple categories, each will be shipped and charged separately based on its category's shipping rates.</p>
          </div>

          <div className="back-link">
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </main>

      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default Shipping;
